import {post} from 'application/api/baseApi';

export type Request = {
  logID?: number; // If provided will MODIFY
  type: string; // If 'DELETE' will DELETE, will require logID
  contact: string;
  date: string;
  userID: string;
  message: string;
};

export type Response = [
  {
    logID?: number;
    type: 'Email' | 'Phone' | 'In-Person' | 'Package' | 'DELETE';
    contact: string;
    date: string;
    userID: string;
    message: string;
  }
];

const path = '/updateContactLog';

/**
 * Middleware for {@link post | the generic API "post" function}.
 * @remark Adds type restrictions and the path parameter.
 * @param req Request body
 * @returns Expected response or null
 */
const updateContactLogAPI = (req: Request) => post<Response>(
  path,
  {
    logID: req.logID,
    type: req.type,
    contact: req.contact,
    date: req.date,
    userID: req.userID,
    message: req.message
  }
);

export default updateContactLogAPI;